export default "__VITE_ASSET__BZDjKzmf__"